import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';
import { Location } from '@angular/common';

import { Helper } from '../../helper';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  profileLink: string;
  token: string;
  displayNav = true;
  activateBookTid: boolean;
  flowType: string;
  superClinicId: string;
  preselectedClinic: string;
  is_logged_in = false;
  service: string;
  singleClinic: string;
  url: string;
  currentUser: any = this.helper.getStorage("currentUser");

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public helper: Helper,
  ) {
    router.events.subscribe((val) => {
      const current_user: any = this.helper.getStorage("currentUser");

      if (
        current_user &&
        current_user.data.email &&
        current_user.data.email !== undefined &&
        current_user.data.CPRNumber &&
        current_user.data.CPRNumber !== undefined
      ) {
        this.is_logged_in = true;
      } else {
        this.is_logged_in = false;
      }

      // see also
      const currentPath = this.location.path();

      if (
        currentPath.includes('/welcome') ||
        currentPath.includes('/login') ||
        currentPath.includes('/signup') ||
        currentPath.includes('/forgot-password')
      ) {
        this.displayNav = false;
      } else {
        this.displayNav = true;
      }

      if (
        currentPath.includes('/body-parts') ||
        currentPath.includes('/find-clinic') ||
        currentPath.includes('/offer-fysiq')
      ) {
        this.activateBookTid = true;
      } else {
        this.activateBookTid = false;
      }
    });
  }

  ngOnInit() {
    const current_user: any = this.helper.getStorage("currentUser");

    if (
      current_user &&
      current_user.data.email &&
      current_user.data.email !== undefined &&
      current_user.data.CPRNumber &&
      current_user.data.CPRNumber !== undefined
    ) {
      this.is_logged_in = true;
    } else {
      this.is_logged_in = false;
    }

    this.route.queryParams.subscribe((params: Params) => {
      this.flowType = params.type;
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.singleClinic = params.singleClinic;

      if (params.bookingToken) {
        this.token = params.bookingToken;
        this.profileLink = '/profile?token=' + this.token;
      } else {
        this.profileLink = '/profile';
      }
    });
  }

  setupUrl(url, extraParams: any = []) {
    let params = {
      type: this.flowType,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    const mergedParams = Object.assign(params, extraParams);

    const navigationExtras: NavigationExtras = {
      queryParams: mergedParams,
    };

    this.router.navigate([url], navigationExtras);
  }

  toProfile() {
    this.setupUrl(this.profileLink);
  }

  myBookings() {
    this.setupUrl('/bookings');
  }

  toWelcome() {
    const current_user: any = this.helper.getStorage("currentUser");

    if (
      current_user &&
      current_user.data.email &&
      current_user.data.email !== undefined
    ) {
      this.setupUrl('/welcome');
    } else {
      localStorage.clear();

      this.setupUrl('/login');
    }
  }

  bookNew() {
    this.setupUrl('/find-clinic');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/navigation.component.ts